/**
 * WinRateTrend — win rate (%) of trades by exit month over the run.
 *
 * Props:
 *   data    from analytics.winRateTrend(trades)  [{bucket:YYYY-MM, winRate, count}]
 *   height  number  SVG height (default 180)
 */

import { Line, LineChart, Tooltip, XAxis, YAxis } from "recharts";

export default function WinRateTrend({ data = [], height = 280 }) {
  if (data.length < 2) return null;

  const avg = data.reduce((a, d) => a + d.winRate, 0) / data.length;
  
  const chartData = data.map((d)=> ({...d}))
  
  return (
    <div className="flex flex-col gap-3" style={{height: `${height}px` }}>
      <div className="flex flex-wrap gap-4 text-xs">
        <span className="flex flex-col">
          <em className="text-[10px] uppercase font-semibold text-muted-foreground not-italic mb-0.5">Avg Win Rate</em>
          <strong className="text-foreground">{avg.toFixed(1)}%</strong>
        </span>
        <span className="flex flex-col">
          <em className="text-[10px] uppercase font-semibold text-muted-foreground not-italic mb-0.5">Months</em>
          <strong className="text-foreground">{data.length}</strong>
        </span>
      </div>

      <LineChart 
        className="text-sm w-full h-full"
        responsive
        margin={{
          top: 20,
          right: 0,
          left: 0,
          bottom: 5,
        }} data={chartData}
      >
        <Tooltip 
          labelStyle={{ color: 'hsl(var(--foreground))' }}
          contentStyle={{background: 'hsl(var(--background))', borderRadius: '8px', border: 'none', boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)' }}
        />

        <XAxis 
          dataKey="bucket"
          axisLine={true} 
          dy={10}
          tick={{fill: 'hsl(var(--foreground))'}}
        />
        <YAxis width="auto" domain={[0, 'dataMax']} 
          tick={{fill: 'hsl(var(--foreground))'}}
        />
        <Line
            dataKey="winRate"
            stroke="hsl(var(--primary))"
            strokeWidth={1}
            dot={false}
            formatter={(v)=> v.toLocaleString('en-IN', { maximumFractionDigits: 0 })}
        />
      </LineChart>
    </div>
  );
}
